import { Col, Row } from 'antd'
import { FC } from 'react'
import Reason from '../../../../../../../../../components/forms/stamp-write-off-form/components/form-items/reason/reason'
import Initiator from '../../../../../../../../../components/forms/stamp-write-off-form/components/form-items/initiator/initiator'

interface WriteOffProps {}

const WriteOff: FC<WriteOffProps> = () => {
    return (
        <Row gutter={18}>
            <Col sm={8}>
                <Reason name={['writeOff', 'reason']} />
            </Col>
            <Col sm={8}>
                <Initiator name={['writeOff', 'initiator']} />
            </Col>
        </Row>
    )
}

export default WriteOff
